import React, { createContext, useState } from "react"

export const defaultLocale = "en"
export const defaultCountry = "US"
export const locales = ["en", "fr"]
export const LanguageContext = createContext<any[]>([])

function isLocale(tested: string) {
	return locales.some((locale) => locale === tested)
}

function getInitialLocale() {
	// preference from the previous session
	const localSetting = localStorage.getItem("locale")
	if (localSetting && isLocale(localSetting)) {
		return { lang: localSetting, country: defaultCountry }
	}

	// the language setting of the browser
	const [browserSetting, country] = navigator.language.split("-")
	if (isLocale(browserSetting)) {
		return { lang: browserSetting, country: country }
	}

	return { lang: defaultLocale, country: defaultCountry }
}

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const [locale, setLocale] = useState(defaultLocale)
	const [country, setCountry] = useState(defaultCountry)

	React.useEffect(() => {
		let { lang, country } = getInitialLocale()
		if (!["fr", "en"].includes(lang)) lang = "en"
		setLocale(lang)
		setCountry(country)
	})

	return (
		<LanguageContext.Provider value={[locale, setLocale, country, setCountry]}>
			{children}
		</LanguageContext.Provider>
	)
}
